import { request } from './http';

export async function getComplianceAspects() {
    return request('/data/compliance-aspects');
  }

export async function getComplianceElements() {
    return request('/data/compliance-elements');
  }

export async function getComplianceElement(id) {
    return request(`/data/compliance-elements/${id}`);
  }

export async function createComplianceElement(data) {
    return request('/data/compliance-elements', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function updateComplianceElement(id, data) {
    return request(`/data/compliance-elements/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

export async function getComplianceAspect(id) {
    return request(`/data/compliance-aspects/${id}`);
  }

export async function createComplianceAspect(data) {
    return request('/data/compliance-aspects', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function updateComplianceAspect(id, data) {
    return request(`/data/compliance-aspects/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

export async function getRecordTypes() {
    return request('/data/record-types');
  }

export async function getRecordType(id) {
    return request(`/data/record-types/${id}`);
  }

export async function createRecordType(data) {
    return request('/data/record-types', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function updateRecordType(id, data) {
    return request(`/data/record-types/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

export async function getCompanyComplianceAspects(companyId) {
    return request(`/customers/${companyId}/aspect-assignments`);
  }

export async function setCompanyComplianceAspects(companyId, aspectIds) {
    return request(`/customers/${companyId}/aspect-assignments`, {
      method: 'PUT',
      body: JSON.stringify({ aspectIds })
    });
  }

export async function getEnvironmentalAspects() {
    return request('/data/environmental-aspects');
  }

export const complianceEnvironmentalAspectsApi = {
  getComplianceAspects,
  getComplianceElements,
  getComplianceElement,
  createComplianceElement,
  updateComplianceElement,
  getComplianceAspect,
  createComplianceAspect,
  updateComplianceAspect,
  getRecordTypes,
  getRecordType,
  createRecordType,
  updateRecordType,
  getCompanyComplianceAspects,
  setCompanyComplianceAspects,
  getEnvironmentalAspects,
};

